<template>
    <div id="arReceiptAndApplication">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> AR Receipts And Applications</div>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- Button for Clear Cache
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'arReceiptsAndApplications'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'arReceiptsAndApplications'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="ARReceiptsAndApplications"
                                    mode="remote"
                                    title="AR Receipts And Applications"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    @on-selected-rows-change="selectionChanged"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: false,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }">
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
let msgServer;
export default {
    name: "ARReceiptsAndApplications",
    metaInfo() {
        return {
            title: "AR Receipts And Applications | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        batchProcess:0,
        batchNum:"",
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label:'Co',
                field:'co',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable : false,
            },
            {
                label:'Receipt',
                field:'receipt_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: "Payment Date",
                field: "payment_date",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
            },
            {
                label: "Applied Date",
                field: "applied_date",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
            },
            {
                label:'Type',
                field:'receipt_item_type',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Payment Number',
                field:'payment_number',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false
            },
            {
                label:'Payment Amount',
                field:'payment_amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
            },
            {
                label: "Customer Number / Addt'l Info",
                field:'invoice_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Entity Name',
                field:'cust_name',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'App Amount',
                field:'application_amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
            },
            {
                label:'Write Off',
                field:'write_off',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable : false,
            },
            {
                label:'Original Amount',
                field:'original_amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
            },
            {
                label:'Remaining Inv Amt',
                field:'remaining_inv_amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
            },
            {
                label:'Current Open Inv Amt',
                field:'current_open_inv_amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
            },
            {
                label:'Invoice / Account',
                field:'invoice_or_account',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                sortable:false
            },
            {
                label:'App Type',
                field:'app_type',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
            },
            {
                label:'Inv Type',
                field:'inv_type',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: "Inv Date",
                field: "invoice_date",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
            },
            {
                label: "Due Date",
                field: "due_date",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
            },
            {
                label:'Applied Description',
                field:'applied_description',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Customer (applied)',
                field:'customer_applied',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Bank Code',
                field:'bank_code',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'AR Acctg Code',
                field:'accounting_code',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
            },
            {
                label:'User ID Added',
                field:'user_added',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: "Date Added",
                field: "created_at",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
            },
            {
                label:'User ID Last Changed',
                field:'user_last_changed',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: "Date Last Changed",
                field: "updated_at",
                hidden:false,
                fpFieldType:"date",
                filterable: true,
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list'
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ar_receipts_and_applications_report') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function () {
        this.serverParams.stopRequest = true;
    },
    beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
    mounted: function() {
        var self = this;

        self.getPermissions();
    },
    methods: {
        // exportReports: function() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
        cancelAll: function (cancelAll) {
          this.$refs.ARReceiptsAndApplications.unselectAllInternal();
        },
        loadList: function() {
            var self = this;

            var selectedRows = [];
            var data = this.$refs['ARReceiptsAndApplications'].selectedRows;
            for ( var i = 0; i < data.length; i++ ) {
                selectedRows.push(this.$refs['ARReceiptsAndApplications'].selectedRows[i].id)
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action,
                selectedAll:self.serverParams.selectedAll,
                selectedRows:selectedRows,
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/report/ar-receipt-and-application",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {


                      if ( self.action == "export" ||  self.action == "export_queue") {

                        if ( data.code == "201" ) {
                            alert(data.message);
                        } else {

                          if ( self.action == "export" ) {

                              self.excel = data.content.web;
                              var save = document.createElement("a");
                              save.href = self.excel;
                              save.download = data.content.web;
                              save.target = "_blank";

                              document.body.appendChild(save);
                              save.click();
                              document.body.removeChild(save);

                          } else {

                              self.batchProcess = 1;
                              self.batchNum = data.content;
                          }

                        }

                        self.action = "list";
                        self.loadList();
                        return;

                    } else {
                      self.rows = data.content.row;
                      self.totalRecords = data.content.totalRecords;

                    }
                     /* if (self.action =='export'){

                        self.action = 'list';
                        if ( data.code == "201" ) {
                            alert(data.message);
                        } else {

                            var excel = data.content.web;
                            var save = document.createElement("a");
                            save.href = excel;
                            save.download = data.content.web;
                            save.target = "_blank";

                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);
                            self.cancelAll(true);
                        }
                        self.loadList();

                      } else {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                      }
                      */
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'ar-receipts-and-applications')
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/ARReceiptsAndApplications.vue